<template>
  <div class="news-detail">
    <h2>{{ datum.title }}</h2>
    <div class="intro">
      <div class="author">
        <!-- <img v-if="datum.authorHead" :src="datum.authorHead" alt="" />
        <img
          v-else
          :src="require('../../assets/images/home/unuser_head.svg')"
          alt=""
        />
        <p>{{ datum.authorName }}</p> -->
        <span>{{ datum.time }}</span>
      </div>
      <div class="attachment" v-if="isShowAttachment">
        <div class="attachment-title">附件下载</div>
        <div class="attachment-item" @click="handleDownload">
          <div class="attachment-badge">DOC</div>
          <div class="attachment-info">
            <p class="attachment-name">申诉受理回执单.doc</p>
            <p class="attachment-tip">{{ isDownloading ? "下载中..." : "点击下载" }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="intro-content">{{ datum.intro }}</div> -->
    </div>
    <div class="news-content" v-html="datum.content"></div>
    <!-- 微信内 iOS 引导提示 -->
    <div class="wechat-tip-mask" v-if="showWechatTip" @click="showWechatTip = false">
      <div class="wechat-tip-arrow">⤴</div>
      <div class="wechat-tip-content">
        <p>请点击右上角 <b>···</b> 按钮</p>
        <p>选择 <b>在浏览器中打开</b></p>
        <p>即可下载附件</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showWechatTip: false,
      isDownloading: false,
      datum: {
        title: "标题",
        authorName: "作者",
        time: "2021 12/22 11:12",
        intro:"",
        content: ``
      }
    };
  },
  computed: {
    // 仅 id 为 36 的新闻显示附件下载
    isShowAttachment() {
      return this.datum && this.datum.id == 142;
    }
  },
  mounted() {
    const data = window.localStorage.getItem("home_news_detail_infos");
     if(this.$route.query.item){
      this.datum = JSON.parse(this.$route.query.item);
    }else if (data) {
      this.datum = JSON.parse(data);
    }
  },
  methods: {
    // 是否微信内置浏览器
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },
    // 是否苹果系统（iOS / iPadOS，含微信内的 iPhone）
    isIOS() {
      const ua = navigator.userAgent;
      return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && "ontouchend" in document);
    },
    handleDownload() {
      // 防止连续点击重复下载
      if (this.isDownloading) return;
      const fileName = "申诉受理回执单.doc";
      const fileUrl = `${process.env.BASE_URL}files/shenshu_shouli_huizhidan.doc`;

      if (this.isWeChat()) {
        // 微信 iOS（含鸿蒙微信 iOS 内核版本）内置浏览器不支持下载，引导用户用浏览器打开
        if (this.isIOS()) {
          this.showWechatTip = true;
          return;
        }
        // 微信安卓 / 鸿蒙：通过 Blob 方式触发系统下载
        this.isDownloading = true;
        this.downloadByBlob(fileUrl, fileName);
      } else {
        // 普通浏览器（含系统浏览器）：直接触发下载
        this.isDownloading = true;
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // 1.5 秒后解锁，允许再次下载
        setTimeout(() => {
          this.isDownloading = false;
        }, 1500);
      }
    },
    // 以 Blob 方式下载（兼容安卓 / 鸿蒙微信及不支持 download 属性的浏览器）
    downloadByBlob(url, fileName) {
      fetch(url, { cache: "no-cache" })
        .then((res) => {
          if (!res.ok) throw new Error("文件获取失败");
          return res.blob();
        })
        .then((blob) => {
          const objectUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = objectUrl;
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => {
            window.URL.revokeObjectURL(objectUrl);
          }, 3000);
        })
        .catch(() => {
          // 降级：直接跳转文件地址，由浏览器自行处理
          window.location.href = url;
        })
        .finally(() => {
          this.isDownloading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.news-detail {
  text-align: left;
  width: 100%;
  max-width: 10rem;
  height: 100%;
  padding: 20px;
  h2 {
    font-size: 18px;
    font-weight: 700;
    color: #666;
    line-height: 28px;
    margin: 0;
  }
  .intro {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f2f2f2;
    .author {
      height: 30px;
      display: flex;
      align-items: center;
      margin-top: 12px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        margin-left: 5px;
        font-size: 13px;
        color: #666;
      }
      span {
        margin-left: 5px;
        color: #999;
      }
    }
    .attachment {
      margin-top: 10px;
      .attachment-title {
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;
      }
      .attachment-item {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        background: #f7f8fa;
        border-radius: 6px;
        cursor: pointer;
        .attachment-badge {
          width: 34px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          background: #2b7cff;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          border-radius: 4px;
          flex-shrink: 0;
        }
        .attachment-info {
          margin-left: 10px;
          .attachment-name {
            margin: 0;
            font-size: 14px;
            color: #333;
          }
          .attachment-tip {
            margin: 2px 0 0;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .intro-content {
      margin-top: 15px;
      font-size: 13px;
      color: #999;
      text-align: justify;
    }
  }
}
</style>
<style lang="scss">
.news-detail {
  .news-content {
    img {
      width: 100%;
    }
    p {
      line-height: 28px;
      font-size: 13px;
      color: #333333;
    }
  }
  .wechat-tip-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
    .wechat-tip-arrow {
      position: absolute;
      top: 20px;
      right: 30px;
      font-size: 40px;
      color: #fff;
      transform: rotate(45deg);
      animation: tip-float 1.2s ease-in-out infinite;
    }
    .wechat-tip-content {
      margin-top: 80px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      line-height: 32px;
      b {
        color: #ffd04b;
      }
    }
  }
  @keyframes tip-float {
    0%,
    100% {
      transform: rotate(45deg) translate(0, 0);
    }
    50% {
      transform: rotate(45deg) translate(-6px, 6px);
    }
  }
}
</style>
